/* 一些颜色集合，目前用于重复 event 标识 */
const colors = ['#F2B4B4', '#E8B4F2', '#C4B4F2', '#B4C7F2', '#B3F1F8', '#FFA1A1', '#A1BEFF', '#F2D6B4', '#EDF2B4', '#B4F2C8', '#BCFF85', '#D88EF2', '#8BEDD6', '#A0A5FF', '#FFD79E']

export default colors
